import React from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as httpService from '../../services/HTTPService';
// import { redirect } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

function ForgotPassForm() {
  const { t } = useTranslation();
  const [validated, setValidated] = useState(false);
  const defaultFormData = {
    email: ""
  }
  let [forgotPassForm, setForgotPassForm] = useState(defaultFormData);

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form: any = event.currentTarget;
    let forgotPassData: any  = {...forgotPassForm};
    const data:any = new FormData(event.currentTarget)
    //let formObject = Object.fromEntries(data.entries())
    let d = data.entries();
    for (let [key, value] of d) {
        forgotPassData[key] = value;
        console.log(key, value);
    }
    forgotPassForm = forgotPassData;
    setForgotPassForm(forgotPassData);
    
    if (form.checkValidity() === true) {
        sendEmail(forgotPassForm);
    }
    setValidated(true);
  };

  const sendEmail = (email: any) => {
    //console.log(email);
    httpService.forgotPass(JSON.stringify(email)).then((res: any) => {
        if(res) {
            //console.log(res);
            if(res.data) {
                let msg = t('forms.resetInstructionsSent');
                toast.success(msg, {
                    autoClose: false
                });
                const registerForm: any = document.querySelector('form');
                registerForm.classList.remove('was-validated');
                registerForm.reset();
            }
        }
    })
    .catch((err) => {
        console.log(err);
        let msg = err.response.data ? err.response.data: t('forms.commonErrMsg');
        if(msg === "Email not found.") {
            msg = t('forms.emailNotFound');
        }
        toast.error(msg, {
            autoClose: false
        });
    })
  }

  return (
    <div>
        <ToastContainer position="top-center"
 />
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="email">
                    <Form.Label>{t('forms.email')}*</Form.Label>
                    <Form.Control 
                        type="email"
                        name="email"
                        required
                    />
                    <Form.Control.Feedback type="invalid">
                        {t('forms.validEmailError')}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} xs="12" controlId="validationCustom09">
                    <div className='align-center btn-out btn-white margin-0'>
                        <Button type="submit">{t('forms.send')}</Button>
                    </div>
                </Form.Group>
            </Row>


        </Form>
    </div>
  );
}

export default ForgotPassForm;